'use client';

import type { PropsWithChildren } from 'react';
import { FinderRefetchContextProvider } from '@frameio/shared/contexts/FinderRefetchContext';
import { useTemporaryFinderRefetch } from '../hooks/useTemporaryFinderRefetch/useTemporaryFinderRefetch';

export function FinderRefetchProvider({ children }: PropsWithChildren) {
  const refetch = useTemporaryFinderRefetch();

  return (
    <FinderRefetchContextProvider refetch={refetch}>
      {children}
    </FinderRefetchContextProvider>
  );
}
